// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","app--dark":"App_app--dark__k5P3Y","app__main":"App_app__main__BbI5C"};